// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ag-Q","label":"SetPasswdForm_label__3-e0L"};